"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inheritedByThisAssetMessage = exports.onThisAssetMessage = exports.catalogLabelAssetTypeToLabelAssetType = exports.labelSubjectArea = exports.isLabelAssetType = exports.labelAssetType = exports.isLabelServiceAssetType = exports.labelServiceAssetType = void 0;
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
/**
 * @internal
 */
exports.labelServiceAssetType = [
    'datasource',
    'database',
    'table',
    'virtualConnection',
    'virtualConnectionTable',
    'flow',
    'column',
];
function isLabelServiceAssetType(value) {
    return exports.labelServiceAssetType.find(t => t === value) !== undefined;
}
exports.isLabelServiceAssetType = isLabelServiceAssetType;
/**
 * @internal
 */
exports.labelAssetType = [
    'CloudFile',
    'DatabaseServer',
    'DatabaseTable',
    'DataCloud',
    'File',
    'Flow',
    'PublishedDatasource',
    'WebDataConnector',
    'VirtualConnectionTable',
    'VirtualConnection',
    'Column',
    'CalculatedInsight',
    'DataLake',
    'DataModel',
];
function isLabelAssetType(value) {
    return exports.labelAssetType.find(t => t === value) !== undefined;
}
exports.isLabelAssetType = isLabelAssetType;
/**
 * @internal
 */
exports.labelSubjectArea = [
    'View',
    'Metric',
    'metric',
    'Workbook',
    'workbook',
    'EmbeddedDatasource',
    'Field',
    'FlowColumnOutputField',
    'FlowFieldOutputField',
];
function catalogLabelAssetTypeToLabelAssetType(type) {
    switch (type) {
        case 'DataCloud':
            return 'database';
        case 'WebDataConnector':
            return 'database';
        case 'DatabaseServer':
            return 'database';
        case 'CloudFile':
            return 'database';
        case 'File':
            return 'database';
        case 'DatabaseTable':
            return 'table';
        case 'Flow':
            return 'flow';
        case 'PublishedDatasource':
            return 'datasource';
        case 'VirtualConnection':
            return 'virtualConnection';
        case 'VirtualConnectionTable':
            return 'virtualConnectionTable';
        case 'Column':
            return 'column';
        case null:
            return null;
        case undefined:
            return undefined;
        default:
            (0, catalog_core_1.assertUnreachable)(type);
            return null;
    }
}
exports.catalogLabelAssetTypeToLabelAssetType = catalogLabelAssetTypeToLabelAssetType;
function onThisAssetMessage(contentType) {
    if (!contentType) {
        return catalog_messages_1.Messages.Label_direct_asset();
    }
    switch (contentType) {
        case 'column':
        case 'Column':
            return catalog_messages_1.Messages.Label_direct_column();
        case 'database':
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'DataCloud':
        case 'WebDataConnector':
            return catalog_messages_1.Messages.Label_direct_database();
        case 'table':
        case 'DatabaseTable':
        case 'VirtualConnectionTable':
        case 'virtualConnectionTable':
            return catalog_messages_1.Messages.Label_direct_table();
        case 'flow':
        case 'Flow':
            return catalog_messages_1.Messages.Label_direct_flow();
        case 'datasource':
        case 'PublishedDatasource':
            return catalog_messages_1.Messages.Label_direct_datasource();
        case 'virtualConnection':
        case 'VirtualConnection':
            return catalog_messages_1.Messages.Label_direct_connection();
        case 'CalculatedInsight':
            return catalog_messages_1.Messages.Label_direct_calculated_insight();
        case 'DataLake':
            return catalog_messages_1.Messages.Label_direct_data_lake();
        case 'DataModel':
            return catalog_messages_1.Messages.Label_direct_data_model();
        default:
            (0, catalog_core_1.assertUnreachable)(contentType);
            return '';
    }
}
exports.onThisAssetMessage = onThisAssetMessage;
function inheritedByThisAssetMessage(contentType, count) {
    if (!contentType) {
        return catalog_messages_1.Messages.Label_inherited_asset();
    }
    switch (contentType) {
        case 'column':
        case 'Column':
            return catalog_messages_1.Messages.Label_inherited_column({
                MESSAGE_COUNT: count !== null && count !== void 0 ? count : 0,
            });
        case 'database':
        case 'CloudFile':
        case 'DatabaseServer':
        case 'File':
        case 'DataCloud':
        case 'WebDataConnector':
            return catalog_messages_1.Messages.Label_inherited_database();
        case 'table':
        case 'DatabaseTable':
        case 'VirtualConnectionTable':
        case 'virtualConnectionTable':
            return catalog_messages_1.Messages.Label_inherited_table();
        case 'flow':
        case 'Flow':
            return catalog_messages_1.Messages.Label_inherited_flow();
        case 'datasource':
        case 'PublishedDatasource':
        case 'EmbeddedDatasource':
            return catalog_messages_1.Messages.Label_inherited_datasource();
        case 'virtualConnection':
        case 'VirtualConnection':
            return catalog_messages_1.Messages.Label_inherited_connection();
        case 'View':
            return catalog_messages_1.Messages.Label_inherited_view();
        case 'Workbook':
        case 'workbook':
            return catalog_messages_1.Messages.Label_inherited_workbook();
        case 'Field':
        case 'FlowColumnOutputField':
        case 'FlowFieldOutputField':
            return catalog_messages_1.Messages.Label_inherited_field({
                MESSAGE_COUNT: count !== null && count !== void 0 ? count : 0,
            });
        case 'Metric':
        case 'metric':
            return catalog_messages_1.Messages.Label_inherited_metric();
        case 'CalculatedInsight':
            return catalog_messages_1.Messages.Label_inherited_calculated_insight();
        case 'DataLake':
            return catalog_messages_1.Messages.Label_inherited_data_lake();
        case 'DataModel':
            return catalog_messages_1.Messages.Label_inherited_data_model();
        default:
            (0, catalog_core_1.assertUnreachable)(contentType);
            return '';
    }
}
exports.inheritedByThisAssetMessage = inheritedByThisAssetMessage;
//# sourceMappingURL=LabelAssetContent.js.map